import TopicOutlinedIcon from '@mui/icons-material/TopicOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';

const menus = [
  {
    key: "automated",
    title: "Projects",
    icon: <TopicOutlinedIcon sx={{ fontSize: "1.125rem" }} />,
    route: "/",
  },
  // {
  //   key: "manual",
  //   title: "Manual",
  //   icon: <FolderSharedOutlinedIcon sx={{ fontSize: "1.125rem" }} />,
  //   route: "/manual",
  // },
];

const tabList = [
  {
    key: "1",
    label: "Notifications",
    icon: <NotificationsNoneOutlinedIcon sx={{ fontSize: "1.125rem" }} />,
    value: "notifications",
  },
  {
    key: "2",
    label: "Security",
    icon: <ShieldOutlinedIcon sx={{ fontSize: "1.125rem" }} />,
    value: "security",
  },
];

export const Constants = {
  AdminMenus: [
    ...menus,
    {
      key: "account",
      title: "Account",
      icon: <CreditCardOutlinedIcon sx={{ fontSize: "1.125rem" }} />,
      route: "/account",
    },
    {
      key: "setting",
      title: "Settings",
      icon: <SettingsOutlinedIcon sx={{ fontSize: "1.125rem" }} />,
      route: "/setting",
    },
  ],
  UserMenus: [
    ...menus,
    {
      key: "setting",
      title: "Settings",
      icon: <SettingsOutlinedIcon sx={{ fontSize: "1.125rem" }} />,
      route: "/setting",
    },
  ],
  AdminTabs: [
    ...tabList,
    {
      key: "3",
      label: "Users",
      icon: <PeopleOutlineOutlinedIcon sx={{ fontSize: "1.125rem" }} />,
      value: "users",
    },
  ],
  UserTabs: [
    ...tabList,
  ],
  Roles: [
    {
      value: "team",
      label: "Team",
      des: "Full access to all projects, settings, and team management",
    },
    {
      value: "guest",
      label: "Guest",
      des: "Access only to assigned projects, cannot manage team",
    },
  ],
  Plans: [
    {
      value: "free",
      label: "Free",
      plan: "FREE",
      isPaid: false,
      des: "Up to 100 redirects per month",
      redirectCount: 100,
      price: 0,
    },
    {
      value: "personal",
      label: "Personal",
      plan: "PERSONAL",
      isPaid: true,
      des: "Up to 1,000 redirects per month",
      redirectCount: 1000,
      price: 79,
    },
    {
      value: "business",
      label: "Business",
      plan: "BUSINESS",
      isPaid: true,
      des: "Up to 10,000 redirects per month",
      redirectCount: 10000,
      price: 249,
    },
    {
      value: "agency",
      label: "Agency",
      plan: "AGENCY",
      isPaid: true,
      des: "Up to 50,000 redirects per month",
      redirectCount: 50000,
      price: 499,
    },
  ],
  Colors: {
    light: {
      background: "#ffffff",
      foreground: "#09090b",
      card: "#ffffff",
      cardForeground: "#09090b",
      popover: "#ffffff",
      popoverForeground: "#09090b",
      primary: "#0b0b0b",
      primaryForeground: "#ffffff",
      secondary: "#f4f4f5",
      secondaryForeground: "#09090b",
      muted: "#f4f4f5",
      mutedForeground: "#71717a",
      accent: "#008b52",
      accentForeground: "#ffffff",
      destructive: "#ef4444",
      destructiveForeground: "#ffffff",
      border: "#e4e4e7",
      input: "#f4f4f5",
      ring: "#22c55e",
      chart1: "#22c55e",
      chart2: "#3b82f6",
      chart3: "#eab308",
      chart4: "#a855f7",
      chart5: "#f97316",
      sidebar: "#ffffff",
      sidebarForeground: "#09090b",
      sidebarPrimary: "#008b52",
      sidebarPrimaryForeground: "#ffffff",
      sidebarAccent: "#f5f5f5",
      sidebarAccentForeground: "#09090b",
      sidebarBorder: "#e4e4e7",
      sidebarRing: "#22c55e",
      success: "#22c55e",
      successForeground: "#ffffff",
      warning: "#eab308",
      warningForeground: "#09090b",
      border: "#0000001f",
    },
    dark: {
      background: "#020817",
      foreground: "#f8fafc",
      card: "#020817",
      cardForeground: "#eee",
      popover: "#020817",
      popoverForeground: "#eee",
      primary: "#c2c6d3",
      primaryForeground: "#020202",
      secondary: "#1e293b",
      secondaryForeground: "#eee",
      muted: "#1e293b",
      mutedForeground: "gray",
      accent: "#23ba7e",
      accentForeground: "#020202",
      destructive: "#7f1d1d",
      destructiveForeground: "#eee",
      border: "#1e293b",
      input: "#1e293b",
      ring: "#e4eafb",
      chart1: "#3b82f6",
      chart2: "#60a8fb",
      chart3: "#3b86f7",
      chart4: "#90c7fe",
      chart5: "#bedcfe",
      sidebar: "#18181b",
      sidebarForeground: "#eee",
      sidebarPrimary: "#23ba7d",
      sidebarPrimaryForeground: "#020202",
      sidebarAccent: "#0b0b0b",
      sidebarAccentForeground: "#eee",
      sidebarBorder: "#161616",
      sidebarRing: "#23ba7d",
      success: "#23ba7d",
      successForeground: "#020202",
      warning: "#dfa11a",
      warningForeground: "#020202",
      border: "#ffffff1f",
    }
  },
  Styles: {
    spacing: "0.25rem",
    container: {
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      "3xl": "48rem",
    },
    fontSize: {
      xs: "0.75rem",
      sm: "0.875rem",
      base: "1rem",
      lg: "1.125rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
    },
    lineHeight: {
      xs: "calc(1 / 0.5)",
      sm: "calc(1.25 / 0.875)",
      base: "calc(1.5 / 1)",
      lg: "calc(1.75 / 1.125)",
      "2xl": "calc(2 / 1.5)",
      "3xl": "calc(2.5 / 1.875)",
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
    tracking: {
      tight: "-0.025em",
      widest: "0.1em",
    },
    leading: {
      snug: 1.375,
      normal: 1.5,
      relaxed: 1.625,
    },
    radius: {
      xs: "0.125rem",
      base: "0.5rem",
    },
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    animate: {
      spin: "spin 1s linear infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    },
    blur: {
      sm: "8px",
    },
    defaultTransition: {
      duration: "0.15s",
      timingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    },
  },
  FontSizes: [
    {
      value: "12px",
      label: "12px"
    },
    {
      value: "14px",
      label: "14px"
    },
    {
      value: "16px",
      label: "16px"
    },
    {
      value: "18px",
      label: "18px"
    },
    {
      value: "20px",
      label: "20px"
    },
    {
      value: "24px",
      label: "24px"
    },
  ],
  StateOptions: [
    { value: "", label: "State" },
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "DC", label: "District Of Columbia" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
  ]
}